export class ParametreGeneral {
  id: number | undefined;
  codeParametre: string;
  libelleParametre: string;
  valeurParametre: string;
  typeParametre: string;
  }